import React, { Component } from 'react'
import { openExternalBrowser } from 'react-wot-bootstrap'
import { floats } from 'react-wot-bootstrap/lib/helpers/format_number'

import {
    RewardPropTypes,
} from 'containers/WGCWXShop/propTypes'
import {
    TTC_TITLE,
    MORE_ABOUT_TANK,
    TANK_TECH_STATS,
 } from '../../translations'

import styles from './TankInfo.scss'

class TankInfo extends Component {
    constructor(props) {
        super(props)
    }

    createOpenTankopediaHandler = infoUrl => event => {
        event.preventDefault()
        openExternalBrowser(infoUrl)
    }

    renderTTCvalue = properties => {
        if (Array.isArray(properties)) {
            return (
                <div className={styles.valueTTC}>
                    {properties.map((property, index) => {
                        const showSeparator = (index !== 0)
                        return (
                            <span key={index}>
                                {showSeparator && <span>{' / '}</span>}
                                <span className={styles.value}>{floats(property, 2)}</span>
                            </span>
                        )
                    })}
                </div>
            )
        }
        return (
            <div className={styles.valueTTC}>
                <span className={styles.value}>{floats(properties, 2)}</span>
            </div>
        )
    }

    render() {
        if (!this.props.selectedTank) {
            return null
        }

        const { selectedTank: { infoUrl }, selectedTank: { vehicleParams: {
            health, hullArmor, avgDamage, piercingPower, clipFireRate, reloadTime, turretArmor,
        } } } = this.props
        return (
            <div className={styles.tankTTC}>
                <div className={styles.titleTTC}>
                    {TTC_TITLE}
                </div>
                <div className={styles.containerTTC}>
                    {health && (
                        <div className={styles.itemTTC}>
                            <div className={styles.nameTTC}>{TANK_TECH_STATS.MAX_HEALTH}</div>
                            <div className={styles.valueTTC}>
                                <span className={styles.value}>{this.renderTTCvalue(health)}</span>
                            </div>
                        </div>
                    )}
                    {hullArmor && (
                        <div className={styles.itemTTC}>
                            <div className={styles.nameTTC}>{TANK_TECH_STATS.HULL_ARMORS}</div>
                            {this.renderTTCvalue(hullArmor)}
                        </div>
                    )}
                    {turretArmor && (
                        <div className={styles.itemTTC}>
                            <div className={styles.nameTTC}>{TANK_TECH_STATS.TURRET_ARMORS}</div>
                            {this.renderTTCvalue(turretArmor)}
                        </div>
                    )}
                    {avgDamage && (
                        <div className={styles.itemTTC}>
                            <div className={styles.nameTTC}>{TANK_TECH_STATS.DAMAGE}</div>
                            {this.renderTTCvalue(avgDamage)}
                        </div>
                    )}
                    {piercingPower && (
                        <div className={styles.itemTTC}>
                            <div className={styles.nameTTC}>{TANK_TECH_STATS.PIERCING}</div>
                            {this.renderTTCvalue(piercingPower)}
                        </div>
                    )}
                    {reloadTime && (
                        <div className={styles.itemTTC}>
                            <div className={styles.nameTTC}>{TANK_TECH_STATS.GUN_RATE_CYCLE}</div>
                            <span className={styles.value}>{this.renderTTCvalue(reloadTime)}</span>
                        </div>
                    )}
                    {clipFireRate && (
                        <div className={styles.itemTTC}>
                            <div className={styles.nameTTC}>{TANK_TECH_STATS.GUN_RATE}</div>
                            <span className={styles.value}>{this.renderTTCvalue(clipFireRate)}</span>
                        </div>
                    )}
                </div>
                {
                    infoUrl &&
                    <a
                        href=""
                        onClick={this.createOpenTankopediaHandler(infoUrl)}
                        className={styles.tankopediaLink}
                    >
                        {MORE_ABOUT_TANK}
                    </a>
                }
            </div>
        )
    }
}

TankInfo.propTypes = {
    selectedTank: RewardPropTypes,
}

export default TankInfo



// WEBPACK FOOTER //
// ./containers/WGCWXShop/containers/WGCWXRewardsTank/components/TankInfo/TankInfo.jsx